import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=cdd3ab9e&scoped=true"
import script from "./AddBrand.vue?vue&type=script&lang=js"
export * from "./AddBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd3ab9e",
  null
  
)

export default component.exports